import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Grid, Button, FormControl, TextField, Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import DoctariCalendar from '../../components/DoctariCalendar';
import LinearLoader from '../../components/LinearLoader';
import Notification from '../../components/Notification';
import { AGENDA } from '../../utils/urls';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DoctariModal from '../../components/Modal';

function Assistant({
  //   doctor,
  classes,
  doctorsInfo,
  appointmentsData,
  deleteMessages,
  getDoctorsInfo,
  createScheduleRequests,
  getScheduleRequests,
  getSchedulesByDate,
  getAppointments,
  clearAppointments,
  getNewAccessToken,
  userState,
  setSelectedDoctor,
  clearSchedules,
  getUserData,
  session,
  clearSelectedDoctor,
}) {
  const theme = useTheme();
  const history = useHistory();

  const [state, setState] = useState({
    dateOfAppointment: null,
    doctorName: null,
    specialty: null,
    country: null,
    type: null,
    availability: true,
    score: false,
    doctorId: null,
    doctorFullData: null,
    // userLoad: false,
  });
  const {
    dateOfAppointment,
    doctorName,
    specialty,
    country,
    type,
    availability,
    score,
    doctorId,
    doctorFullData,
    // userLoad,
  } = state;

  const { countries, specialities, numOfPages, doctors, currentPage } =
    doctorsInfo;
  const [userLoad, setUserLoad] = useState(false);
  const [createAppointmentModalOpen, setCreateAppointmentModalOpen] =
    useState(false);
  const [specialtyName, setSpecialtyName] = useState('');
  const [doctorSpecialty, setDoctorSpecialty] = useState([]);
  const [doctorSlot, setDoctorSlot] = useState(null);

  useEffect(() => {
    if (specialtyName != null && userLoad) {
      setDoctorSpecialty(
        userState.user.doctors.filter((doctor) => {
          return doctor.specialty.id == specialtyName.id && doctor.is_active;
        })
      );
    }
  }, [specialtyName]);

  useEffect(() => {
    // getDoctorsInfo([], []);
    getUserData(session.userType, session.id);
    if (doctorsInfo.selectedDoctor != null) {
      setState({
        ...state,
        doctorId: doctorsInfo.selectedDoctor.id,
        doctorFullData: doctorsInfo.selectedDoctor,
      });
    }
  }, []);

  useEffect(() => {
    if (doctorId) {
      //   getDoctorsInfo([], [], currentPage, doctor.accessToken);
      setSelectedDoctor(doctorFullData);
      setDoctorSlot(doctorFullData.specialty.duration.minutes);
      getScheduleRequests(`?doctor=${doctorId}`);
      // getSchedulesByDate(
      //   moment()
      //     .day(1)
      //     .set('hour', '00')
      //     .set('minute', '00')
      //     .add(0, 'days')
      //     .format('YYYY-MM-DD HH:mm'),
      //   moment().day(1).add(7, 'days').format('YYYY-MM-DD HH:mm'),
      //   doctorId
      // );
    } else {
      clearSchedules();
      clearSelectedDoctor();
      setState({
        ...state,
        doctorId: null,
      });
    }
  }, [doctorId]);

  useEffect(() => {
    if (userState.user) {
      if (userState.user.doctors) {
        setUserLoad(true);
      }
    }
  }, [userState.user]);

  useEffect(() => {
    if (appointmentsData.appointmentCreated) {
      if (appointmentsData.appointmentCreated.patient_link) {
        setCreateAppointmentModalOpen(true);
      }
    }
  }, [appointmentsData.appointmentCreated]);

  // useEffect(() => {
  //   if (doctorId) {
  //     let queryParams = ['date__gt'];
  //     let queryValues = [
  //       moment().subtract(2, 'hours').format('YYYY-MM-DD HH:mm'),
  //     ];

  //     getAppointments(
  //       'doctor',
  //       doctorId,
  //       false, //isDone
  //       queryParams,
  //       queryValues
  //     );
  //   }
  //   return () => clearAppointments();
  // }, [doctorId]);

  // useEffect(() => {
  //   if (doctorId == '') {
  //     console.log('ENTRO ACA POR VACIO');
  //   }
  //   console.log('CUANDO VUELVO EL DOCTOR ES ', doctorId);
  //   // console.log('ESTE ES EL NOMBRE DEL DOCTOR ', doctorFullName);
  // }, [doctorId]);

  const handleChangeDoctorId = (e, value) => {
    if (value == null) {
      // console.log('este valor es null en handle');
      clearSelectedDoctor();
      clearSchedules();
      setState({
        ...state,
        doctorId: null,
        doctorFullData: null,
      });
      // console.log('seguro no es cero pero ', appointmentsData.schedules);
    } else {
      setState({
        ...state,
        doctorId: value.id,
        doctorFullData: value,
      });
    }
  };

  const ClipboardCopy = ({ copyText, label }) => {
    const [isCopied, setIsCopied] = useState(false);

    // This is the function we wrote earlier
    async function copyTextToClipboard(text) {
      if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
      } else {
        return document.execCommand('copy', true, text);
      }
    }

    // onClick handler function for the copy button
    const handleCopyClick = () => {
      // Asynchronously call copyTextToClipboard
      copyTextToClipboard(copyText)
        .then(() => {
          // If successful, update the isCopied state value
          setIsCopied(true);
          setTimeout(() => {
            setIsCopied(false);
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '1rem',
        }}
      >
        <TextField
          id='my-input'
          aria-describedby='my-helper-text'
          // onChange={(e) =>
          //   setDataPatient({ ...dataPatient, name: e.target.value })
          // }
          // type="text"
          style={{ width: '80%' }}
          variant='outlined'
          value={copyText}
          size='small'
          label={label}
          readOnly
        />
        {/* <input type="text" value={copyText} readOnly /> */}
        {/* Bind our handler function to the onClick button property */}
        <Button
          style={{ float: 'right', margin: '10px' }}
          variant='text'
          color='primary'
          //disabled={!attachments.length}
          onClick={handleCopyClick}
        >
          <span>{isCopied ? 'Copiado!' : 'Copiar'}</span>
        </Button>
        {/* <button onClick={handleCopyClick}>
          <span>{isCopied ? 'Copied!' : 'Copy'}</span>
        </button> */}
      </Box>
    );
  };
  // const handlePrueba = (option, value) => {
  //   console.log('estos son los valores de handle prueba ', option, value);
  //   return option.id === doctorFullData.id;
  // };

  return (
    <>
      {doctorsInfo.loading && <LinearLoader />}
      {/* {appointmentsData.success && (
        <Notification
          type='success'
          message={'Consulta creada exitosamente'}
          onCloseCallback={deleteMessages}
        />
      )}
      /* {appointmentsData.error && (
        <Notification
          type='error'
          message={'No se pudo crear la solicitud, intentelo de nuevo'}
          onCloseCallback={deleteMessages}
        />
      )} */}
      {/* {appointmentsData.success.genericMessage ==
        'Appointment creado con exito' && (
        <Notification
          type="success"
          message={'Consulta creada con éxito'}
          onCloseCallback={deleteMessages}
        />
      )} */}
      {appointmentsData.success.genericMessage ==
        'Appointment eliminado con exito' && (
        <Notification
          type='error'
          message={'Consulta cancelada'}
          onCloseCallback={deleteMessages}
        />
      )}
      <DoctariModal
        open={createAppointmentModalOpen}
        setOpen={(val) => setCreateAppointmentModalOpen(val)}
        title={'Consulta creada'}
      >
        <ClipboardCopy
          copyText={
            appointmentsData.appointmentCreated
              ? appointmentsData.appointmentCreated.patient_link
              : ''
          }
          label='Link paciente'
        />
        <ClipboardCopy
          copyText={
            appointmentsData.appointmentCreated
              ? appointmentsData.appointmentCreated.video_conference_code
              : ''
          }
          label='Código paciente'
        />
        <p style={{ margin: '5%' }}>
          Se ha enviado un mail al paciente y al doctor especificando los datos
          la consulta.
        </p>

        <Button
          style={{ float: 'right', margin: '10px' }}
          variant='contained'
          color='primary'
          onClick={() => {
            setCreateAppointmentModalOpen(false);
          }}
        >
          Aceptar
        </Button>
      </DoctariModal>
      <Grid
        container
        direction='row'
        item
        xs={11}
        md={12}
        style={{ padding: '1rem 0 0 3rem', gap: '1rem' }}
      >
        <FormControl className={classes.formControl}>
          <Autocomplete
            disablePortal
            id='combo-box-demo'
            options={
              userLoad
                ? userState.specialities.filter((specia) => {
                    return specia.name;
                  })
                : []
            }
            getOptionLabel={(option) => option.name || ''}
            sx={{ width: 300 }}
            onChange={(event, value) => setSpecialtyName(value)}
            value={specialtyName}
            renderInput={(params) => (
              <TextField {...params} label='Especialidad' />
            )}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            disablePortal
            id='combo-box-demo'
            options={
              userLoad
                ? !specialtyName
                  ? userState.user.doctors.filter((doctor) => {
                      return doctor.is_active;
                    })
                  : doctorSpecialty
                : []
            }
            getOptionLabel={(option) => option.full_name || ''}
            sx={{ width: 300 }}
            value={doctorsInfo.selectedDoctor}
            onChange={handleChangeDoctorId}
            onInputChange={doctorId ? history.push(AGENDA) : ''}
            renderInput={(params) => (
              <TextField {...params} label='Seleccione un doctor' />
            )}
          />
        </FormControl>
      </Grid>
      <Grid
        container
        direction='column'
        alignItems='center'
        style={{ flexWrap: 'initial', fontFamily: theme.typography.fontFamily }}
      >
        {/* <MyAppointments
          appointmentData={appointmentsData}
          theme={theme}
          isProfessional={true}
          classes={classes}
          session={doctor}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
        ></MyAppointments> */}

        <Grid item xs={11} md={12}>
          <DoctariCalendar
            currentWeek={0}
            schedules={appointmentsData.schedules}
            slot={session.slot}
          >
            {/* <Button 
              disabled={!doctorFullData}
              onClick={() => history.push(AGENDA)}
              variant="contained"
              color="primary"
              style={{ width: '206px' }}
            >
              {'Editar calendario'}
            </Button> */}
          </DoctariCalendar>
        </Grid>
      </Grid>
    </>
  );
}

export default Assistant;
